module.exports = __webpack_public_path__ + "img/icon-diningroom.492ece47.svg";